const riot = require('riot');

riot.tag2('atom-input-tags', '<form class="input f fm w-full overflow-x-scroll scrollbar-none" onsubmit="{onSubmit}"> <div class="f fm bg-white py1 px4 rounded-4 border flex-fixed lh15 fs10 bold mr4" each="{value, index in values}"><span># </span><span>{value}</span></div> <input class="min-width-100 w-full lh15 fs13 outline-none" ref="input" type="text" placeholder="タグ" onkeydown="{onKeyDown}" onblur="{onBlur}" readonly="{opts.readonly}"> </form>', '', '', function(opts) {
    this.values = [];

    this.onSubmit = (e) => {
      e.preventDefault();
      e.stopPropagation();

      var input = this.refs.input;
      var value = input.value.trim();

      if (value) {
        this.values.push(value);
      }
      input.value = '';
      input.focus();
    };

    this.onKeyDown = (e) => {
      var input = this.refs.input;
      var value = input.value.trim();
      var code = e.keyCode;
      var isBackspace = code === 8;
      var isEnter = code === 13;

      if (isEnter && !value) {
        this.trigger('submit');
      }

      if (isBackspace && !input.value) {

        this.values.pop();
        riot.update();
      }
    };

    this.onBlur = async (e) => {
      var input = e.currentTarget;
      if (input.value) {
        this.values.push(input.value);
        input.value = '';
        this.update();
      }
    };

    this.setValues = (values) => {
      this.values = values.concat();
      this.update();
    };

    this.getValues = () => {
      var input = this.refs.input;

      var value = input.value.trim();

      if (value) {

        this.values.push(value);
        input.value = '';
        this.update();
      }

      return this.values;
    };

    this.clearValues = () => {
      this.values = [];
      this.update();
    };
});